import { Injectable, signal } from '@angular/core';

/** Back link shown in the layout header breadcrumb row. */
export interface HeaderBreadcrumbBack {
  backLabel: string;
  backRoute: string[];
}

/** Route `data` keys consumed by {@link PageHeaderStore}. */
export interface PageHeaderRouteData {
  pageTitle?: string;
  headerBreadcrumb?: HeaderBreadcrumbBack;
}

/**
 * Global reactive store for layout header content driven by the active route.
 * Updated by Layout on navigation and by feature pages when values are dynamic.
 */
@Injectable({ providedIn: 'root' })
export class PageHeaderStore {
  readonly title = signal('');
  readonly breadcrumbBack = signal<HeaderBreadcrumbBack | null>(null);

  syncFromRouteData(data: PageHeaderRouteData | undefined): void {
    this.title.set(data?.pageTitle ?? '');
    this.breadcrumbBack.set(data?.headerBreadcrumb ?? null);
  }

  setTitle(title: string): void {
    this.title.set(title || 'Home');
  }
}
